module.exports = __webpack_public_path__ + "static/media/manage-notification.704778ae.svg";